function getCurrentDate() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1;
  var yy = today.getFullYear();
  return "".concat(yy, "-").concat(mm < 10 ? '0' + mm : mm, "-").concat(dd < 10 ? '0' + dd : dd);
}

export { getCurrentDate };
